import { __zcFin, __zcIT, __zcITc, __zcIV, __zcMkv, __zcRd, __zcRf } from "__zod-compiler-runtime__";
import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'

export const FootnoteSchema = /* @__PURE__ */ (() => {
var __zs=buildEntrySchemaFor('footnote', {
  fields: z.lazy(() =>
    z.object({
      text: RichTextSchema,
    }),
  ),
});
var __rf=[__zs._zod.innerType.shape["sys"].shape["contentType"]];
var __rfz_0=__rf[0]._zod;
function safeParse_FootnoteSchema(input){
var _e=[];
var _d=input;
if(typeof _d!=="object"||_d===null||Array.isArray(_d)){_e.push(__zcIT("object",_d,[]));}else{var __sv_1=_d["sys"];if(typeof __sv_1!=="object"||__sv_1===null||Array.isArray(__sv_1)){_e.push(__zcIT("object",__sv_1,["sys"]));}else{var __sv_3=__sv_1["id"];if(typeof __sv_3!=="string"){_e.push(__zcIT("string",__sv_3,["sys","id"]));}
var __sv_4=__sv_1["updatedAt"];if(__sv_4!==undefined){if(typeof __sv_4!=="string"){_e.push(__zcIT("string",__sv_4,["sys","updatedAt"]));}
}
var __sv_5=__sv_1["createdAt"];if(__sv_5!==undefined){if(typeof __sv_5!=="string"){_e.push(__zcIT("string",__sv_5,["sys","createdAt"]));}
}
var __sv_6=__sv_1["contentType"];var __op_8="contentType" in __sv_1;var __ob_7=_e.length;var __rf_c0={async:false};var __rf_r0=__zcRd(__rfz_0,__sv_6,__rf_c0);if(__rf_r0.issues.length){__zcRf(__rf_r0.issues,__rf_c0,_e,["sys","contentType"]);}else{__sv_6=__rf_r0.value;}
if(!__op_8){__sv_6=undefined;if(_e.length===__ob_7){_e.push(__zcITc("nonoptional",undefined,["sys","contentType"]));}}var __o_2={"id":__sv_3};if(__sv_4!==undefined||("updatedAt" in __sv_1)){__o_2["updatedAt"]=__sv_4;}if(__sv_5!==undefined||("createdAt" in __sv_1)){__o_2["createdAt"]=__sv_5;}if(__sv_6!==undefined||("contentType" in __sv_1)){__o_2["contentType"]=__sv_6;}__sv_1=__o_2;}
var __sv_9=_d["fields"];if(typeof __sv_9!=="object"||__sv_9===null||Array.isArray(__sv_9)){_e.push(__zcIT("object",__sv_9,["fields"]));}else{var __sv_11=__sv_9["text"];if(typeof __sv_11!=="object"||__sv_11===null||Array.isArray(__sv_11)){_e.push(__zcIT("object",__sv_11,["fields","text"]));}else{var __sv_13=__sv_11["nodeType"];if(!(__sv_13==="document")){_e.push(__zcIV(["document"],__sv_13,["fields","text","nodeType"]));}var __sv_14=__sv_11["data"];if(typeof __sv_14!=="object"||__sv_14===null||Array.isArray(__sv_14)){_e.push(__zcIT("object",__sv_14,["fields","text","data"]));}else{var __o_15={};__sv_14=__o_15;}
var __sv_16=__sv_11["content"];if(!Array.isArray(__sv_16)){_e.push(__zcIT("array",__sv_16,["fields","text","content"]));}else{var __ar_17=__sv_16;for(var __i_18=0;__i_18<__ar_17.length;__i_18++){var __mv_19=__ar_17[__i_18];}__sv_16=__ar_17;}
var __o_12={"nodeType":__sv_13,"data":__sv_14,"content":__sv_16};__sv_11=__o_12;}
var __o_10={"text":__sv_11};__sv_9=__o_10;}
var __o_0={"sys":__sv_1,"fields":__sv_9};_d=__o_0;}

if(_e.length===0){return{success:true,data:_d};}
return __zcFin(_e,_d);
}
return __zcMkv(safeParse_FootnoteSchema,__zs,null,null);
})()

export type Footnote = z.infer<typeof FootnoteSchema>
